import * as moment from "moment";
import * as React from 'react';
var Loader = require('react-loaders').Loader;

import * as classNames from "classnames";
import { withTheme } from '../../../common/withTheme';
import CustomSelect from '../../common/CustomSelect';
import DateTimePicker from '../../common/DateTimePicker';
import { FilterState } from '../../../reducers/filter.reducer';
import * as DTOS from '../../../FeralScan.dtos';
import { FilterSearchPropsAndActions } from "..";

interface IFeralScanFilterSearchProps {
}

type FeralScanFilterSearchProps = FilterSearchPropsAndActions & IFeralScanFilterSearchProps;

class FilterSearch extends React.PureComponent<FeralScanFilterSearchProps, any> {
    constructor(props: FeralScanFilterSearchProps, context) {
        super(props, context);

        this.onSearchClicked = this.onSearchClicked.bind(this);

        this.onDateRangeChanged = this.onDateRangeChanged.bind(this);
        this.onSelectedGroupsChanged = this.onSelectedGroupsChanged.bind(this);
        this.onSelectedRegionChanged = this.onSelectedRegionChanged.bind(this);
        this.onSelectedSpeciesChanged = this.onSelectedSpeciesChanged.bind(this);
        this.onSelectedTypeChanged = this.onSelectedTypeChanged.bind(this);
        this.onSelectedQuestionChanged = this.onSelectedQuestionChanged.bind(this);
        this.onSelectedTypeChanged = this.onSelectedTypeChanged.bind(this);
        this.onStartDateChange = this.onStartDateChange.bind(this);
        this.onEndDateChange = this.onEndDateChange.bind(this);
        this.onSaveFilterClicked = this.onSaveFilterClicked.bind(this);
        this.onShowAdvancedClicked = this.onShowAdvancedClicked.bind(this);
        this.saveFilter = this.saveFilter.bind(this);
        this.onPrintClicked = this.onPrintClicked.bind(this);

        this.onRadioButtonClick = this.onRadioButtonClick.bind(this);

        this.onShowSaveFilter = this.onShowSaveFilter.bind(this);
        this.onHideSaveFilter = this.onHideSaveFilter.bind(this);

        //this.initFilters = this.initFilters.bind(this);
    }

    /*
    temporarily moved to PageSummary
    componentDidMount() {

        var newFilter: FilterState = { ...this.props.filter };

        const startDate = moment(this.props.queryDateStart ? this.props.queryDateStart : newFilter.startDate);
        const endDate = moment(this.props.queryDateEnd ? this.props.queryDateEnd : newFilter.endDate);

        if (this.props.queryCommunityGroupId) {
            let selectedGroups: DTOS.QuestionOption[] = [];

            if (newFilter.selectedGroups && newFilter.selectedGroups !== null) {
                selectedGroups = newFilter.selectedGroups;
            }

            if (this.props.queryCommunityGroupId == -99) {
                newFilter.selectedDataView = 'mydata';
                const group = new DTOS.QuestionOption();
                group.label = 'No group';
                group.rank = 0;
                group.type = '';
                group.value = this.props.queryCommunityGroupId.toString();
                selectedGroups.push(
                    group
                );
            } else if (this.props.queryCommunityGroupId > 0) {
                newFilter.selectedDataView = 'groups';
            }

            var groupData = this.props.referenceData.groups.find(g => Number(g.value) === this.props.queryCommunityGroupId)

            if (groupData) {
                const group = new DTOS.QuestionOption();
                group.label = groupData.label ? groupData.label : 'No group';
                group.rank = 0;
                group.type = groupData.type ? groupData.type : '';
                group.value = this.props.queryCommunityGroupId.toString();

                selectedGroups.push(
                    group
                );

                newFilter.selectedGroups = selectedGroups;
            }
        }

        newFilter.startDate = startDate;
        newFilter.endDate = endDate;
        newFilter.defaultDateSpan = undefined;
        newFilter.selectedDateRange = undefined;

        this.props.updateFilters(newFilter);
    }
*/
    /*componentDidUpdate(prevProps: FeralScanFilterSearchProps) {
        if (this.props.filter &&
            this.props.filter.startDate &&
            this.props.filter.endDate &&
            prevProps.currentUser === this.props.currentUser // check if user is same to avoid reapplying filter on logout
        ) {

            var filterChange = false;

            var newFilter: FilterState = { ...this.props.filter };

            // this needs to be remade for the typing and handling of classifications
            //if (this.props.classificationFilter && this.props.referenceData && this.props.referenceData.classifications) {
            //    // if classification filter isn't already in the selected classifications, add it
            //    if (this.props.classificationFilter != "all" && !this.props.filter.selectedClassifications.find(r => { return r.label.toLowerCase() === this.props.classificationFilter.toLowerCase() })) {
            //        var classificationOption = this.props.referenceData.classifications
            //            .find(
            //                r => {
            //                    return r.label.toLowerCase() === this.props.classificationFilter.toLowerCase()
            //                })
            //
            //        //newFilter.selectedClassifications.push(classificationOption);
            //
            //        this.props.updateFilters(newFilter);
            //        filterChange = true;
            //    }
            //}

            if (!filterChange) {
                this.props.search(this.props.filter);
            }

            //
        }
    }*/

    onShowAdvancedClicked() {
        //this.setState({ showAdvancedFilter: !this.state.showAdvancedFilter });
    }
    onShowSaveFilter() {
        //this.setState({ showSaveFilterModal: true });
    }
    onHideSaveFilter() {
        //this.setState({ showSaveFilterModal: false });
    }

    async onSelectedSpeciesChanged(value) {
        //this.setState({ selectedClassifications: value });
    }

    async onSelectedTypeChanged(value) {

        var classifications = [].concat.apply(this.props.filter.selectedClassifications, value);
        this.props.getQuestions(classifications);

        //this.setState({ selectedTypes: value });
    }

    async onSelectedQuestionChanged(value) {
        //this.setState({ selectedQuestions: value });
    }

    onSelectedGroupsChanged(group) {
        let selectedGroups: DTOS.QuestionOption[] = [];

        var newFilter: FilterState = { ...this.props.filter };

        //if (newFilter.selectedGroups && newFilter.selectedGroups !== null) {
        //    selectedGroups = newFilter.selectedGroups;
        //}

        selectedGroups.push(
            group
        );

        newFilter.selectedGroups = selectedGroups;

        this.props.updateFilters(newFilter);
    }

    async onSelectedRegionChanged(value) {
        //this.setState({ selectedRegion: value });
    }

    onPrintClicked() {
        //this.props.print(this.state);
    }
    onSearchClicked() {
        //this.props.onFilterChanged(this.state);
        //this.props.search(this.state);
    }

    onStartDateChange(date) {
        var startDate = moment(date ? date : this.props.filter.startDate);
        var defaultDateSpan = startDate.diff(date, 'days');

        var newFilter: FilterState = { ...this.props.filter };

        newFilter.startDate = startDate;
        newFilter.defaultDateSpan = defaultDateSpan;

        this.props.updateFilters(newFilter);
    }

    onEndDateChange(date) {
        var endDate = moment(date ? date : this.props.filter.endDate);
        var defaultDateSpan = date.diff(endDate, 'days');

        var newFilter: FilterState = { ...this.props.filter };

        newFilter.endDate = endDate;
        newFilter.defaultDateSpan = defaultDateSpan;

        this.props.updateFilters(newFilter);
    }

    onFilterChanged(filter) {

        if (filter) {
            //var filterParsed = filter ? JSON.parse(filter) : undefined;

        }
    }

    onDateRangeChanged(selectedDateSpan) {


        if (selectedDateSpan) {
            var startDate = moment()
                .add(selectedDateSpan.dateStartDifference, 'days')
                .startOf('day');

            var endDate = moment().endOf('day');

            var newFilter: FilterState = { ...this.props.filter };

            newFilter.endDate = endDate;
            newFilter.startDate = startDate;
            newFilter.selectedDateRange = selectedDateSpan;

            this.props.updateFilters(newFilter);
        } else {
            var newFilter: FilterState = { ...this.props.filter };

            newFilter.selectedDateRange = undefined;

            this.props.updateFilters(newFilter);
        }
    }
    onSaveFilterClicked(preferences) {
        this.saveFilter(preferences);
        this.onHideSaveFilter();
    }

    onRadioButtonClick(e) {
        var newFilter: FilterState = { ...this.props.filter };
        newFilter.selectedDataView = e.target.value;

        switch (e.target.value) {
            case 'mydata':
                let selectedGroups: DTOS.QuestionOption[] = [];
                const group = new DTOS.QuestionOption();
                group.label = '';
                group.rank = 0;
                group.type = '';
                group.value = "-99";

                selectedGroups.push(
                    group
                );

                newFilter.selectedGroups = selectedGroups;
                break;
            case 'groups':
                newFilter.selectedGroups = [];
                break;
            case 'alldata':
                newFilter.selectedGroups = [];
                break;
        }

        this.props.updateFilters(newFilter);
    }


    saveFilter(preferences) {

        var days = this.props.filter.endDate.diff(this.props.filter.startDate, 'days');

        var preferences = { ...preferences };
        preferences.defaultDateSpan = days;
        //const { value, label } = this.props.filter ? this.props.filter : { value: null, label: null };

        var filters = {
            defaultDateSpan: days,
            selectedDateRange: this.props.filter.selectedDateRange,
            selectedGroups: this.props.filter.selectedGroups,
            selectedClassifications: this.props.filter.selectedClassifications,
            selectedQuestions: this.props.filter.selectedQuestions,
            showAdvancedFilter: this.props.filter.showAdvancedFilter,
        };

        this.props.saveFilter(preferences, filters);
    }

    render() {
        const { classifications, dateRanges, types } = this.props.referenceData;
        /*
                var groupsFilterSelect = groups.length > 0 ?
                    <div className="col-12 py-1">
                        <CustomSelect
                            label="Group"
                            placeholder="View Group Data"
                            className="form-control-small"
                            options={groups}
                            value={this.props.filter.selectedGroups && this.props.filter.selectedGroups[0] ? this.props.filter.selectedGroups[0] : undefined}
                            onChange={this.onSelectedGroupsChanged}
                        />
                    </div> : <span>You are not the member of any groups.</span>;
        */
        var dateFilter =
            <div className="col-12 mt-2">
                <div className="d-flex justify-content-between align-items-center">
                    <DateTimePicker
                        className="form-control-date"
                        name="startDate"
                        onChange={this.onStartDateChange}
                        value={this.props.filter.startDate}
                        dateFormat="DD/MM/YYYY"
                    />
                    <span className="mx-0">to</span>
                    <DateTimePicker
                        className="form-control-date"
                        name="endDate"
                        onChange={this.onEndDateChange}
                        value={this.props.filter.endDate}
                        dateFormat="DD/MM/YYYY"
                    />
                </div>
            </div>;
        /*
                var savedFilterSelect = savedFilters.length > 0 ?
                    <div className="col-12">
                        <CustomSelect
                            label="Saved Filters"
                            placeholder="Saved Filters"
                            className="form-control-small"
                            options={savedFilters}
                            //value={this.props.filter}
                            value={""}
                        //onChange={this.onFilterChanged}
                        />
                    </div> : undefined;
        */

        const filterHeader =
            <div className="row">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <h6 className="m-0"><strong>DISPLAY SETTINGS</strong></h6>
                </div>
            </div>;

        let detailedFilterForm = this.props.filter.showAdvancedFilter ?
            <div className="row no-gutters">
                <div className="col-12">
                    <CustomSelect
                        label={"Species"}
                        multi
                        placeholder={"Species"}
                        className="form-control-small"
                        options={classifications}
                        value={this.props.filter.selectedClassifications}
                        onChange={this.onSelectedSpeciesChanged}
                    />
                </div>
                <div className="col-12">
                    <CustomSelect
                        label={"Types"}
                        multi
                        placeholder={"Types"}
                        className="form-control-small"
                        options={types}
                        value={this.props.filter.selectedTypes}
                        onChange={this.onSelectedTypeChanged}
                    />
                </div>
                {/*
                <div className="col-12">
                    <CustomSelect
                        label="Data Fields"
                        multi
                        placeholder="Data Fields"
                        className="form-control-small"
                        options={questions}
                        value={this.props.filter.selectedQuestions}
                        onChange={this.onSelectedQuestionChanged}
                    />
                </div>
*/}
            </div>
            : undefined;

        return (
            this.props.show ?
                <div className="bg-white p-3">
                    {filterHeader}
                    <div className="row no-gutters mt-1">
                        <div className="col-12">
                            <CustomSelect
                                label="Date Period"
                                placeholder=""
                                className="my-1 form-control-small"
                                options={dateRanges}
                                value={this.props.filter.selectedDateRange}
                                onChange={this.onDateRangeChanged}
                            />
                        </div>
                        {this.props.filter && this.props.filter.selectedDateRange && this.props.filter.selectedDateRange.value === "custom" ? dateFilter : undefined}
                    </div>
                    {detailedFilterForm}
                </div>
                : <span></span>
            /* 
        {detailedFilterForm}
        {
            this.props.currentUser && this.props.currentUser.id ? <div>
                <div className="row no-gutters mt-3">
                    <label>
                        <input type="radio" name="MyData" value='mydata' checked={this.props.filter.selectedDataView == 'mydata'} readOnly onClick={this.onRadioButtonClick} />
                        <span className="pl-1">My Data</span>
                    </label>
                </div>
                <div className="row no-gutters">
                    <label>
                        <input type="radio" name="PublicData" value='alldata' checked={this.props.filter.selectedDataView == 'alldata'} readOnly onClick={this.onRadioButtonClick} />
                        <span className="pl-1">All Data</span>
                    </label>
                </div>
                <div className="row no-gutters">
                    <label>
                        <input type="radio" name="Groups" value='groups' checked={this.props.filter.selectedDataView == 'groups'} readOnly onClick={this.onRadioButtonClick} />
                        <span className="pl-1">My Group</span>
                    </label>
                    {this.props.filter.selectedDataView == 'groups' ? groupsFilterSelect : undefined}
                </div>
            </div> : undefined
        }
            */
        );
    }
}

export default withTheme<FeralScanFilterSearchProps>(FilterSearch);